import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import {
  navBar,
  mainBody,
  about,
  education,
  project,
  publication,
  skills,
  getInTouch,
  experiences,
} from "./editable-stuff/config.js";
import MainBody from "./components/home/MainBody";
import AboutMe from "./components/home/AboutMe";
import Project from "./components/home/Project";
import Publication from "./components/home/Publication";
// import ProjectA from "./components/home/ProjectA";
import Footer from "./components/Footer";
import Research from "./components/research/Research.jsx";
import Navbar from "./components/Navbar";
import Skills from "./components/home/Skills";
import Education from "./components/home/Education.jsx";
// import { Blog } from "./components/blog/Blog";
// import BlogPost from "./components/blog/BlogPost";
import GetInTouch from "./components/home/GetInTouch.jsx";
import Experience from "./components/home/Experience";


// const Research = () =>{
//   return (
//       <div className="container">
//           <h1>Research paper in progress</h1>
//           <p>Hence, the code is not publicly available</p>
//       </div>
//   );
// };


const Home = React.forwardRef((props, ref) => {
  // const titleRef = React.useRef();
  console.log(skills)
  return (
    <>
      <MainBody
        gradient={mainBody.gradientColors}
        title={`${mainBody.firstName} ${mainBody.middleName} ${mainBody.lastName}`}
        message={mainBody.message}
        icons={mainBody.icons}
        ref={ref}
      />

      {navBar.show && <Navbar ref={ref} />}

      {about.show && (
        <AboutMe
          heading={about.heading}
          message={about.message}
          link={about.imageLink}
          imgSize={about.imageSize}
          resume={about.resume}
        />
      )}

      {education.show && (
        <Education educations = {education} />
      )}
      {skills.show && (
        <Skills
          heading={skills.heading}
          hardSkills={skills.hardSkills}
          hardSkills1={skills.hardSkills1}
        />
      )}
      {
        experiences.show && (
          <Experience experiences={experiences}/>
        )
      }
      {project.show && (
        <Project project={project}
        />
      )}
      {publication.show && (
        <Publication publication={publication}
        />
      )}
      {getInTouch.show && (
          <GetInTouch
            heading={getInTouch.heading}
            message={getInTouch.message}
            email={getInTouch.email}
          />
      )}
        {/* {getInTouch.show && (
          <GetInTouch
            heading={getInTouch.heading}
            message={getInTouch.message}
            email={getInTouch.email}
          />
        )} */}
    </>
  );
});

const App = () => {
  const titleRef = React.useRef();
  const reload = () => window.location.reload();

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      {/* {navBar.show && <Navbar ref={titleRef} />} */}
      <Routes>
        <Route path="/" exact element={<Home ref={titleRef} />} />
        {/* <Route exact path="/research.html" element={reload} /> */}
        <Route exact path="/research" render={() => {window.location.href="research.html"}} />
        
      </Routes>
      {/* {false && <Route path="/blog" exact component={Blog} />}
      {false && <Route path="/blog/:id" component={BlogPost} />} */}
      {/* <Footer> */}
      {/* </Footer> */}
    </BrowserRouter>
  );
};

export default App;
